import React from 'react';
import PlusIcon from "../../assets/icons/plus-small.svg";
import MinusIcon from "../../assets/icons/minus.svg";
import { HInput, passParamsThrough } from "../../validation/HForm";

const emptyRow = {
  carModel: "",
}

const CarModelRows = ({
    rows,
    onEntityChange,
    getValues,
    reset,
    control,
    register,
    errors,
}) => {

  const props = {
    control,
    register,
    errors,
  };

  const handleAddAfter = (index) => {
    if (onEntityChange) {
      let values = getValues()
      values.rows.splice(index + 1, 0, emptyRow);
      reset({
        rows: values.rows
      })
      onEntityChange(values.rows);

    }
  }

  const handleRemove = (index) => {
    if (onEntityChange) {
      let values = getValues();
      values.rows.splice(index, 1);
      reset({
        rows: values.rows
      })
      onEntityChange(values.rows);
    }
  }

  let range = new Array(rows.length)
    .fill(undefined).map((_, i) => i);

  return passParamsThrough(
    <ol className="rowsArea">
      {range.map(number => {
        return (
          <li key={number}>
            <div className="table-cell-actions">
                <div className="rowsArea-inputWrapper">
                    <HInput
                        h="true"
                        className="input"
                        type="text"
                        name={`rows[${number}].carModel`}
                        id={`carModel${number}`}
                        defaultValue={rows[number].carModel}
                    />
                </div>
              <button
                className="button-icontrigger"
                type={"button"}
                onClick={() => handleAddAfter(number)}
              >
                <span className="icon">
                  <PlusIcon/>
                </span>
              </button>
              { !(rows.length === 1) &&
                <button
                  className="button-icontrigger"
                  type={"button"}
                  onClick={() => handleRemove(number)}
                >
                  <span className="icon">
                    <MinusIcon/>
                  </span>
                </button>
              }
            </div>
          </li>
        )
      })}
    </ol>, props);
}

export default CarModelRows;
